
<template>
  <div class="container-fluid h-100">
    <div class="row h-100 align-items-center">
      <div class="col">
        <h5 class="text-center text-success">
          <router-link to="/userpanel">برای ورود به پنل اینجا را کلیک نمایید</router-link>
        </h5>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "Alert",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>
<style>
</style>
